import React from 'react';
import { Typography } from '@mui/material';

const EmailPage: React.FC = () => (
  <div>
    <Typography variant="h4">Email Campaigns</Typography>
    <Typography>Email campaign management will be implemented here.</Typography>
  </div>
);

export default EmailPage;